import React from "react";
import Select from "react-select";

export default function AddAssignUpdatePopUp({ setshowUpdatePopUp,UpdatePopUpData,Toast,setloading,setisPost,isPost }) {

  const UserID = sessionStorage.getItem("userID")
  const {popUpData} = UpdatePopUpData
  const [SurveyorDDL, setSurveyorDDL] = React.useState([])
  const [SurveyorID, setSurveyorID] = React.useState(0)
  const [SurveyorName, setSurveyorName] = React.useState('')

  const [DistrictDDL, setDistrictDDL] = React.useState([])
  const [DistrictID, setDistrictID] = React.useState(popUpData ? popUpData.m_DistrictID :0)
  const [DistrictName, setDistrictName] = React.useState('')

  const [TalukaDDL, setTalukaDDL] = React.useState([])
  const [TalukaID, setTalukaID] = React.useState(0)
  const [TalukaName, setTalukaName] = React.useState('')

  const Add = (Flag, showData) => {

  }

  const SaveSucess = (Flag) => {
    Add(Flag)
  }


  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title ml-4" id="exampleModalLongTitle">
              District/ Taluka wise Surveyor Mapping
              </h5>
              <button
                onClick={() => setshowUpdatePopUp(false)}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row">
                <div className=" col-lg-4">
                  <div className="form-group m-0">
                    <label>Surveyor Name<span style={{ color: 'red', fontSize: 14 }}> *</span></label>
                    <Select
                      isClearable
                      autoFocus
                      id="branch"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: '#363738',  // Placeholder color
                        },
                      })}
                      value={SurveyorName}
                    //   placeholder={SurveyorName === "" ? "Select..." : SurveyorName}
                      placeholder={SurveyorName === "" && popUpData.surveyorName !== null ? popUpData.surveyorName : SurveyorName}
                      options={
                        SurveyorDDL ? SurveyorDDL.map(item => ({
                          ID: item.m_TableUserMasterID,
                          label: item.employeeName

                        })) : 'Loading'
                      }
                      onChange={(e) => {
                        console.log(e)
                        setSurveyorID(e !== null ? e.ID : '');
                        setSurveyorName(e !== null ? e.label : '');
                        setDistrictID("0")
                        setDistrictName("Select...")
                        setTalukaID("0")
                        setTalukaName("Select...")

                      }}
                    />
                  </div>
                </div>
                <div className=" col-lg-4">
                  <div className="form-group m-0">
                    <label>District<span style={{ color: 'red', fontSize: 14 }}> *</span></label>
                    <Select
                      isClearable
                      autoFocus
                      id="branch"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: '#363738',  // Placeholder color
                        },
                      })}
                      value={DistrictName}
                    //   placeholder={DistrictName === "" ? "Select..." : DistrictName}
                      placeholder={DistrictName === "" && popUpData.districtName !== null ? popUpData.districtName : DistrictName}
                      options={
                        DistrictDDL ? DistrictDDL.map(item => ({
                          ID: item.id,
                          label: item.districtName

                        })) : 'Loading'
                      }
                      onChange={(e) => {
                        console.log(e)
                        setDistrictID(e !== null ? e.ID : '');
                        setDistrictName(e !== null ? e.label : '');
                        setTalukaID("0")
                        setTalukaName("Select...")

                      }}
                    />
                  </div>
                </div>
                <div className=" col-lg-4">
                  <div className="form-group m-0">
                    <label> Taluka<span style={{ color: 'red', fontSize: 14 }}> *</span></label>
                    <Select
                      isClearable
                      autoFocus
                      id="branch"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: '#363738',  // Placeholder color
                        },
                      })}
                      value={TalukaName}
                    //   placeholder={TalukaName === "" ? "Select..." : TalukaName}
                      placeholder={TalukaName === "" && popUpData.talukaName !== null ? popUpData.talukaName : TalukaName}
                      options={
                        TalukaDDL ? TalukaDDL.map(item => ({
                          ID: item.id,
                          label: item.talukaName

                        })) : 'Loading'
                      }
                      onChange={(e) => {
                        console.log(e)
                        setTalukaID(e !== null ? e.ID : '');
                        setTalukaName(e !== null ? e.label : '');

                      }}
                    />
                  </div>
                </div>


                <div className="col-12 mt-3">
                  <div className="form-group float-right">
                    <button
                      disabled={SurveyorID === " " || DistrictID === " " || TalukaID === " "|| DistrictName === "Select..." || TalukaName === "Select..." }
                      type="button"
                      onClick={() => SaveSucess("Update")}
                      className="btn btn-add btn-md"
                      data-ktwizard-type="action-next"
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      onClick={() => setshowUpdatePopUp(false)}
                      className="btn clear-btn btn-md"
                      data-ktwizard-type="action-next"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
